import { Component, OnDestroy, OnInit } from '@angular/core';
import { CmProAuthService } from '@app/core/services';
import { AppSettings } from "@app/cp/shared/models/AppSettings";
import { UsersBus } from '@app/cp/shared/models/UsersBus.model';
import { CommonValues } from '@app/cp/shared/static/CommonValues';

@Component( {
    selector: 'cp-dispatch-obj-loader-calendar',
    templateUrl: './dispatch-obj-loader-calendar.component.html',
    styleUrls: [ './dispatch-obj-loader-calendar.component.scss' ]
} )
export class DispatchObjLoaderCalendarComponent implements OnInit, OnDestroy {

    userList = ['1', '2', '3', '4', '5', '6', '7', '8','9', '10' ];
    randomNumber: number;

    userSetttings: AppSettings = new AppSettings();
    columnWidth: Number = 250;

    constructor(private authService: CmProAuthService) {
    }

    ngOnInit() {
        this.randomNumber = Math.floor(Math.random() * 10) + 1;
        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                var settings = JSON.parse(localStorage.getItem(CommonValues.StorageKeys_UserSettings));
                this.userSetttings.setSettingsLoad(settings);
                this.columnWidth = this.userSetttings.DispatchBoardStatusWidth;
            }
        });

    }

    ngOnDestroy(): void {
        this.authService.unsubscribeToLoginEvents();
    }
}
